import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '@/common/date.service';

@Pipe({
	name: 'formatDateTime',
})
export class FormatDateTimePipe implements PipeTransform {
	constructor(private readonly dateService: DateService) {}

	transform(value: string): string {
		if (typeof value !== 'string') throw new Error('Date have to be a string!');
		return this.dateService.formatDateToGivenLocale(value, 'sv-SE');
	}
}
